const module = { name: 'theater/shared/theaterAmenities', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile }, featureFlags: { usePopovers }, theater } } = Fandango_context;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { Fandango_overlay as fdOverlay } from 'base-libraries';



import { swig as swig } from 'require-core';



import { Fandango_dropdown as dropdown } from 'base-libraries';



const Selectors = {
    AMENITIES_CONTAINER: '#theater-details-amenities',
    INFO_SECTION: '#theater-details-header-info-section',
    OPEN_BTN: '#theater-amenities-overlay-open-btn',
}


const Styles = {
    AMENITIES_CONTAINER: 'theater-amenities-overlay__container',
    AMENITIES_CONTAINER_DESKTOP: 'theater-amenities-overlay__container--desktop',
    CLOSE_BTN: 'theater-amenities-overlay__close-btn',
}


const DROPDOWN_NAME = 'theaterAmenitiesDesktop'
function launchTrack(platform) {
    track({
        event: EventTypes.MODAL,
        pageType: 'modal',
        platform,
        server: 'fandango responsive',
        modalName: 'theaters | theater detail'
    });
}
function onClick(e) {
    const isDesktop = !isMobile;
    const markup = swig.render('_theaterAmenitiesOverlay', {
        theater,
        isDesktop
    });
    if (isDesktop) {
        dropdown.open(markup, {
            closeBtnParent: Selectors.AMENITIES_CONTAINER,
            closeBtnStyle: Styles.CLOSE_BTN,
            dropdownStyle: Styles.AMENITIES_CONTAINER_DESKTOP,
            name: DROPDOWN_NAME,
            openParent: e.currentTarget.id,
            relativeParent: Selectors.INFO_SECTION,
        });
        launchTrack('fandango web');
    }
    else {
        fdOverlay.open(markup, {
            closeBtnParent: Selectors.AMENITIES_CONTAINER,
            closeBtnStyle: Styles.CLOSE_BTN,
            overlayStyle: Styles.AMENITIES_CONTAINER
        });
        launchTrack('fandango mobile web');
    }
}
function init() {
    const btn = document.querySelector(Selectors.OPEN_BTN);
    if (!btn || usePopovers) {
        return;
    }
    btn.addEventListener('click', onClick);
}
module.exports = {
    init,
};
export default module.exports;